<div class="oa-sheet item-details-config-modal">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>
            Visualização do item
            <span class="oa-sheet__subtitle">{{ data.itemName }}</span>
        </h2>
        <button type="button" class="oa-icon-btn" (click)="cancel()" [disabled]="saving" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body">
        <div class="item-info">
            <p class="hint">Escolha quais informações detalhadas deste item aparecem no orçamento.</p>
            <p class="hint info" *ngIf="!data.itemId">
                <mat-icon>info</mat-icon>
                Esta configuração será salva junto com o item quando você salvar o orçamento.
            </p>
        </div>

        <mat-divider></mat-divider>

        <div class="config-fields">
            <!-- Toggle principal "Não exibir" -->
            <div class="hide-item-toggle">
                <mat-slide-toggle
                    [checked]="hideItem"
                    (change)="onHideItemChange($event)"
                    color="warn">
                    Não exibir detalhes deste item
                </mat-slide-toggle>
                <p class="hint-toggle" *ngIf="hideItem">
                    Este item não será exibido na seção de detalhes do orçamento.
                </p>
            </div>

            <mat-divider></mat-divider>

            <h3 [class.disabled]="hideItem">Campos a exibir</h3>

            <div class="fields-list" [class.disabled]="hideItem">
                <mat-checkbox
                    *ngFor="let item of displayFields"
                    [checked]="item.value"
                    [disabled]="hideItem"
                    (change)="onCheckboxChange($event, item.field)"
                    color="primary">
                    {{ item.label }}
                </mat-checkbox>
            </div>
        </div>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" (click)="cancel()" [disabled]="saving">
            Cancelar
        </button>
        <button type="button" class="oa-btn oa-btn--primary" (click)="concluir()" [disabled]="saving"
            [attr.aria-busy]="saving ? 'true' : null">
            <span *ngIf="saving" class="oa-spinner" aria-hidden="true"></span>
            Concluir
        </button>
    </footer>
</div>
